import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'
import Request from './request'
import appConfig from '../app.config'
export default class UserService {

    constructor () {
        this.key = 'thebigquiz-token'
        this.feideKey = 'feide-data-token'
    }

    setToken (token) {
        Cookies.set(this.key, token)
        localStorage.setItem(this.key, token)

        const user = jwtDecode(token)

        if (user.sub.provider === 'feide' && user.sub.email && !this.getFeideToken()) {
            Cookies.set(this.feideKey, this.encode({ feide_email: user.sub.email }))
            localStorage.setItem(this.feideKey, this.encode({ feide_email: user.sub.email }))
        }
    }

    getToken () {
        const token = Cookies.get(this.key)

        return token ? token : ''
    }

    getFeideToken () {
        const token = Cookies.get(this.feideKey)

        return token ? token : ''
    }

    getTokenFromStorage () {

        const token = localStorage.getItem(this.key)

        return token ? token : ''
    }

    getFeideTokenFromStorage () {
        const token = localStorage.getItem(this.feideKey)

        return token ? token : ''
    }

    isLoggedIn () {
        const token = this.getToken()

        if (!token.length) {
            return false
        }

        const payload = jwtDecode(token)
        const currentTime = new Date().getTime() / 1000

        return currentTime < payload.exp
    }

    getUser () {
        const token = this.getToken()

        if (!token) {
            this.removeToken()
            return false
        }

        const user = jwtDecode(token).sub

        if (['teacher', 'teacher_plus', 'student', 'student_plus'].includes(user.role)) {
            if (user.provider === 'feide') {
                const feideCookie = this.getFeideToken()

                if (!feideCookie) {
                    this.removeToken()
                    return false
                }

                user.email = this.decode(feideCookie).feide_email
            }
        }

        return user
    }

    getUserFeide () {
        let token = this.getFeideToken()

        if (!token) {
            token = this.getFeideTokenFromStorage()
        }

        try {
            return this.decode(token)

        } catch {
            return false
        }

    }

    removeToken () {
        Cookies.remove(this.key)
        localStorage.removeItem(this.key)

        // this.removeFeideToken()
    }

    removeFeideToken () {
        Cookies.remove(this.feideKey)
        localStorage.removeItem(this.feideKey)
    }

    validateToken () {

        return new Promise((resolve, reject) => {

            let token = this.getToken()
            let storageToken = this.getTokenFromStorage()

            if (!token && storageToken) {
                token = ''
            }

            if (!token) {
                return reject()
            }

            var request = new Request({
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })

            request.post(appConfig.api.validateToken)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {

                    if (err.message != 'Network Error') {
                        this.removeToken()
                    }

                    reject(err)
                })
        })
    }

    encode(data) {
        return btoa(JSON.stringify(data))
    }

    decode(data) {
        return JSON.parse(atob(data))
    }
}

export function currentUser () {
    const service = new UserService

    return service.getUser()
}

export function isLoggedIn () {
    const service = new UserService

    return service.isLoggedIn()
}

export function removeToken () {
    const service = new UserService

    return service.removeToken()
}

export function removeFeideToken () {
    const service = new UserService

    return service.removeFeideToken()
}

export function validateToken() {
    const service = new UserService

    return service.validateToken()
}

export function getToken() {
    const service = new UserService

    return service.getToken()
}
